module.exports = __webpack_public_path__ + "img/m-icon10.a48c6b08.png";